<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/addedServices"></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox @query="inputBoxClick"></inputBox>
    </div>

    <!-- 面包屑 -->
    <!-- <div class="title-left">
      <el-breadcrumb>
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/layout/list/addedServices"
          >增值服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>正文</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->

    <div class="box-content">
      <div class="content-left">
        <!-- <bookDetailCards></bookDetailCards> -->
        <!-- 第一个模块 -->
        <div class="left-one">
          <bookDetailCards :info="mydata.dataInfo"></bookDetailCards>
          <!-- <p class="one-p" style="cursor: pointer">
            <el-icon><Star /></el-icon>
            <span> 加入收藏</span>
          </p> -->
          <!-- 加入收藏 -->
          <p
            v-if="mydata.dataInfo.is_collect === 0"
            class="one-p"
            @click="isCollect"
          >
            <el-icon><Star /></el-icon>
            <span>加入收藏</span>
          </p>
          <!-- 取消收藏 -->
          <p v-else class="one-p" @click="isCollect">
            <el-icon class="collectTrue"><Star /></el-icon>
            <span class="collectTrue">取消收藏</span>
          </p>
          <div
            class="book-intro"
            v-if="mydata.dataInfo.description === ''"
          >
            <p>图书介绍</p>
            <div
              class="tableA"
              style="
                line-height: 200px;
                text-align: center;
                letter-spacing: 1px;
                font-size: 16px;
                font-weight: 400;
                color: #999999;
              "
            >
              暂无介绍
            </div>
          </div>
          <div
            class="book-intro"
            v-else
            :style="mydata.infoBoxStyle"
            ref="infoBox"
          >
            <p>图书介绍</p>
            <p class="tableA" v-html="mydata.dataInfo.description"></p>
            <!-- <img v-complete:src="mydata.dataInfo.img_url" /> -->
          </div>
          <!-- 上下箭头区域 -->
          <div class="bottom-and-top" v-if="mydata.bottomAndTopShow">
            <el-divider>
              <div
                v-if="mydata.bottomAndTop === 'bottom'"
                @click="bottomAndTopClick('bottom')"
              >
                <el-icon><CaretBottom /></el-icon>
                <p>点我展开</p>
              </div>
              <div
                v-if="mydata.bottomAndTop === 'top'"
                @click="bottomAndTopClick('top')"
              >
                <el-icon><CaretTop /></el-icon>
                <p>点我收起</p>
              </div>
            </el-divider>
          </div>
        </div>
        <!-- 第二个模块 ————目录-->
        <div class="left-two">
          <!-- <bookListCards></bookListCards> -->
          <div v-if="mydata.resourceArr.length === 0">
            <p
              style="
                line-height: 250px;
                text-align: center;
                letter-spacing: 1px;
                color: #333333;
                color: #999999;
              "
            >
              暂无数据
            </p>
          </div>
          <div class="book-list" v-else>
            <el-tabs v-model="mydata.resourceActive" class="demo-tabs">
              <el-tab-pane
                v-for="(item, index) in mydata.resourceArr"
                :key="index"
                :label="item.name"
                :name="item.id"
              >
                <el-row class="heades-top">
                  <el-col :span="14" class="first-box">名称</el-col>
                  <!-- <el-col :span="4">价格</el-col>
                  <el-col :span="4">是否免费</el-col> -->
                  <el-col :span="6" style="border-left: 1px solid #eceef9"
                    >下载次数</el-col
                  >
                  <el-col :span="4" style="border-left: 1px solid #eceef9"
                    >下载</el-col
                  >
                </el-row>

                <div class="my-row-box">
                  <el-row
                    class="heades-content"
                    style="height: 50px; line-height: 50px"
                    v-for="(item2, index2) in item.list"
                    :key="index2"
                  >
                    <el-col
                      :span="14"
                      class="first-box"
                      style="text-align: left"
                    >
                      {{ item2.show_name }}</el-col
                    >
                    <!-- <el-col :span="4">
                    {{
                      item2.point_price === 0 ? "暂无定价" : item2.point_price
                    }}</el-col
                  > -->
                    <!-- 0否 1是 -->
                    <!-- <el-col :span="4">
                    {{ item2.free_see === 0 ? "否" : "是" }}</el-col
                  > -->
                    <el-col :span="6" style="border-left: 1px solid #eceef9">
                      {{ item2.download_num }}</el-col
                    >
                    <el-col :span="4" style="border-left: 1px solid #eceef9">
                      <el-icon @click="downloadButton(item2)"
                        ><Download /></el-icon
                    ></el-col>
                  </el-row>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>

      <!-- 右侧推荐区域 -->
      <div>
        <!-- 必备好书 -->
        <rightCardBook title="必备好书"></rightCardBook>
        <!-- 必刷好题 -->
        <rightCardProblem title="必刷好题"></rightCardProblem>
        <!-- 必学好课 -->
        <rightCardCourse title="必学好课"></rightCardCourse>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "booksDetails",
});
</script>
<script setup>
// 必备好书
import rightCardBook from "@/components/rightCardBook/index.vue";
// 必刷好题
import rightCardProblem from "@/components/rightCardProblem/index.vue";
// 必学好课
import rightCardCourse from "@/components/rightCardCourse/index.vue";

import { useRouter, useRoute } from "vue-router";

import { reactive, watch, ref, nextTick, onBeforeUnmount } from "vue";

import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import bookDetailCards from "@/components/bookDetailCards/index.vue";

import { Star, Download, CaretBottom, CaretTop } from "@element-plus/icons-vue";

import { bookInfo } from "@/api/addedServices/index.js";

// 引入加入收藏接口
import { addFavoritesList } from "@/api/personalCenter/myCollection/index.js";
// 引入详情页取消收藏接口
import { cancelCollect } from "@/api/addedServices/index.js";

//引入增值详情下载接口
import { downloadAddServices } from "@/api/addedServices/index.js";
//引入淘题首页接口
import { getBlobByUrl } from "@/api/boutiqueTaobaoQuestions/topicSubjectDetails/index.js";

import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  book_id: {},
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  dataInfo: {}, //详情对象
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  resourceArr: [],
  resourceActive: "",
  progressValue: "",
  loadingShow: false,
  infoBoxStyle: {
    "max-height": "500px",
    overflow: "hidden",
  },
  bottomAndTop: "bottom",
  bottomAndTopShow: false,
});

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
    // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes("/layout/list/booksDetails")) {
      return;
    }
    getData();
  },
  {
    immediate: true,
  }
);

const infoBox = ref();
// 使用定时器，10秒钟检测10次
let intervalId = null;
// 当前检测次数
let num = 0;
onBeforeUnmount(() => {
  clearInterval(intervalId);
});

function bottomAndTopClick(val) {
  console.log(val);
  // 改变箭头
  mydata.bottomAndTop = val === "bottom" ? "top" : "bottom";
  // 改变样式
  mydata.infoBoxStyle["max-height"] = val === "bottom" ? "none" : "500px";
}

function getData() {
  mydata.book_id = route.query.id;
  bookInfo(mydata.userInfo?.jwt, { book_id: mydata.book_id }).then((res) => {
    // bookInfo(mydata.userInfo?.jwt, { book_id: 1651 }).then((res) => {
    mydata.dataInfo = res.data;
    if (!Array.isArray(mydata.dataInfo.resource)) {
      mydata.resourceArr = Object.values(mydata.dataInfo.resource);
      mydata.resourceActive = mydata.resourceArr[0].id;
      // console.log(mydata.resourceArr, "增值详情");
    }
    mydata.dataInfo.description = mydata.dataInfo.description.replace(
      /[\n\r]/gi,
      "<br>"
    );
    // console.log(mydata.dataInfo,"增值详情");
    // console.log(mydata.resourceArr,"tabs详情");
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.dataInfo.title;
    // console.log(mydata.dataInfo, "增值");
    /////////////////////
    // 如果详情内容撑开的盒子高度大于500px，那么就显示上下箭头盒子，否则就不显示上下箭头盒子
    nextTick(() => {
      // setTimeout(() => {
      //   // console.log(infoBox.value.scrollHeight);
      //   // console.log(window.document.getElementsByClassName("tableA")[0].scrollHeight);
      //   mydata.bottomAndTopShow =
      //     infoBox.value && infoBox.value.scrollHeight > 500 ? true : false;
      // }, 0);
      // 定时器
      intervalId = setInterval(() => {
        // 检测详情盒子的真实高度，并控制上下箭头的显示隐藏
        mydata.bottomAndTopShow =
          infoBox.value && infoBox.value.scrollHeight > 500 ? true : false;
        // 检测次数加一
        num = num + 1;
        // 如果检测次数达到10次了 或者 上下箭头已经显示了，那么就不需要再继续监测了，那么就清除定时器
        if (num >= 10 || mydata.bottomAndTopShow) {
          clearInterval(intervalId);
        }
      }, 1000);
    });
    /////////////////////
  });
}

// getData();

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.dataInfo.is_collect !== 0) {
    // 调用详情页取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      type: 2,
      content_id: mydata.dataInfo.id,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      getData();
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.dataInfo.id,
      type: 2,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      getData();
    });
  }
}

const loading = ref();

// 进度函数
function progressFn(resultNumber) {
  // 如果不可出现loading加载了，那么就直接终止代码
  if (!mydata.loadingShow) {
    return;
  }
  // console.log(112);

  // 赋值
  mydata.progressValue = resultNumber;
  // 需要注意的是，以服务的方式调用的全屏 Loading 是单例的。
  loading.value = ElLoading.service({
    lock: true,
    text: mydata.progressValue + "%",
    background: "rgba(255, 255, 255, 0.8)",
  });
  // 设置文本内容（它会执行多次）
  loading.value.setText(mydata.progressValue + "%");
  // 如果进度是100了，那就关闭loading加载（它可能不准确）
  if (mydata.progressValue === 100) {
    loading.value.close();
  }
}

//增值下载
async function downloadButton(item) {
  let res = await downloadAddServices({
    id: item.id,
    book_id: item.book_id,
    resource_id: item.resource_id,
  });
  let arr1 = res.data.url.split(",");
  // 下载文件 start ///////////////////////////////////////
  for (const item of arr1) {
    let ele = document.createElement("a");
    ele.href = item;
    ele.click();
  }
  // 下载文件 end ///////////////////////////////////////
  // console.log(arr1);
  // arr1.forEach(async (item) => {
  //   let arr = item.split("/");
  //   let name = arr[arr.length - 1];
  //   // // 可以出现loading加载了
  //   // mydata.loadingShow = true;
  //   // let res2 = await getBlobByUrl(item, progressFn);
  //   // // 不可出现loading加载了
  //   // mydata.loadingShow = false;
  //   // // 关闭loading加载
  //   // loading.value.close();
  //   // // 清空loading文本
  //   // mydata.progressValue = "";

  //   // let url = URL.createObjectURL(res2);
  //   let ele = document.createElement("a");
  //   ele.href = item;
  //   ele.target = "_blank";
  //   ele.download = name;
  //   ele.click();
  // });
}

function inputBoxClick(type, value) {
  localStorage.setItem("v", value);
  router.push({
    path: "/layout/list/addedServices",
    // query: {
    //   search: value,
    // },
  });
}
</script>

<style scoped lang="scss">
.my-li {
  > p:nth-of-type(1) {
    width: calc(100% - 0px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    cursor: pointer;
  }
}

////////模块1————最顶部的title
// .title-left {
//   width: 1200px;
//   height:20px;
//   margin: 0 auto;
//   // border: 1px solid blue;
//   margin-top: 40px;
//   margin-bottom: 20px;
//   display: flex;
//   align-items: center;
//   font-size: 14px;
//   font-weight: 400;
//   color: #bbbdbf;
//   .line {
//     margin: 0px 8px;
//   }
//   p:hover {
//     color: #009de0;
//   }
// }

.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px !important; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
    
  }

  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    margin-top: 16px;
    // display: flex;
    // justify-content: space-between;

    /////左边
    .content-left {
      // width: 860px;
      // height: 1000px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;
      ////第一个模块
      .left-one {
        // height: 833px;
        // border:1px solid pink;
        margin-bottom: 16px;
        // padding: 30px;
        background-color: #ffffff;
        border-radius: 8px;
        //////图书详情卡片组件
        :deep(.book-detail) {
          margin: 0 auto;
          margin-top: 16px;
          //  border: 1px solid red;
        }
        //////加入收藏
        .one-p {
          width: 343px;
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin: 0 auto;
          // margin-top: 10px;
          // border: 1px solid red;
          position: relative;
          cursor: pointer;
          :deep(.el-icon) {
            font-size: 24px;
            line-height: 24px;
            position: absolute;
            right: 70px;
            top: -1px;
          }
          span {
            position: absolute;
            right: 0px;
            top: -1px;
          }
        }
        .collectTrue {
          color: #009de0;
        }
        .one-p:hover {
          color: #009de0;
        }
        //////图书介绍
        .book-intro {
          width: 343px;
          margin: 0 auto;
          margin-top: 10px;
          margin-bottom: 16px;
          border-top: 1px dashed #cccccc;
          // border:1px solid red;
          p:nth-of-type(1) {
            // font-size: 16px;
            font-weight: 700;
            color: #333333;
            line-height: 24px;
            margin-top: 24px;
            margin-bottom: 12px;
            
          }
          p:nth-of-type(2) {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #333333 !important;
            margin-bottom: 20px;
          }
          img {
            width: 343px;
            height: 193px;
            // font-size:0;
            // max-width: 100%;
            margin: 0 auto !important;
            display: block;
          }
        }
      }
      //////第二个模块
      .left-two {
        background-color: #ffffff;
        border-radius: 8px;
        margin-bottom: 16px;
        .book-list {
          // border: 1px solid rgb(0, 4, 255);
          padding-bottom: 16px;

          // 目录的内容
          :deep(.demo-tabs > .el-tabs__content) {
            // padding: 0px 16px 16px 16px;
            width: 343px;
            // height: 634px;
            // border: 1px solid red;
            background-color: #ffffff;
            border-radius: 8px;
            margin: 0 auto;
          }

          //////每个目录的宽度
          :deep(.el-tabs__item.is-top) {
            width: auto;
            height: 54px;
            text-align: center;
            padding: 0px !important;
            // margin-right: 40px;
            margin: 0px 10px;

            font-size: 16px;
            font-weight: 700;
            letter-spacing: 1px;
            // color:red;
          }

          :deep(.el-tabs__nav-scroll) {
            overflow-x: auto;

            /* 针对webkit内核浏览器 */
            ::-webkit-scrollbar {
              display: none; /* 隐藏滚动条 */
            }

            /* 针对Firefox */
            scrollbar-width: none; /* Firefox中隐藏滚动条 */

            /* 针对IE和Edge */
            -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
          }

          //目录左右两边箭头
          :deep(.el-tabs__nav-wrap.is-scrollable.is-top) {
            padding: 0px;
            overflow-x: auto;

            .el-tabs__nav-prev {
              height: 44px;
              line-height: 44px;
              font-size: 16px;
              margin-top: 3px;
              display: none;
            }
            .el-tabs__nav-next {
              height: 44px;
              line-height: 44px;
              font-size: 16px;
              margin-top: 3px;
              display: none;
            }
          }

          //类型（名称、价格、是否免费、下载次数、下载）
          .heades-top {
            height: 50px;
            line-height: 50px;
            font-weight: 700;
            letter-spacing: 1px;
            color: #333333;
            background-color: #f7f9fa;
            //  padding:0px 20px;
            margin-bottom: 20px;
            //居中
            :deep(.el-col) {
              text-align: center;
            }
          }
          //内容盒子
          .heades-content {
            // border:1px solid rgb(0, 85, 255);
            margin-top: 20px;
            background-color: #fafcff;
            border: 1px solid #eceef9;
            border-radius: 4px;
            font-size: 15px;
            //图标
            :deep(.el-icon) {
              font-size: 20px;
              cursor: pointer;
            }

            //每一条字体居中
            :deep(.el-col) {
              text-align: center;
            }
            //下载
            :deep(.el-col.el-col-4) {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            :deep(.el-col.el-col-4):hover {
              color: #009de0;
            }
          }
          .heades-content:first-of-type {
            margin-top: 0px;
          }
          //名称
          .first-box {
            padding: 0px 10px;
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //文本溢出 用省略号显示
            overflow: hidden;
            // display: -webkit-box;
            // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            // text-overflow: ellipsis; //文本溢出 用省略号显示
            // -webkit-line-clamp: 2; //几行
            // overflow: hidden;
          }

          .my-row-box {
            // border: 1px solid red;
            overflow-y: auto;
            // max-height: 500px;
            height: 470px;
          }
          .my-row-box::-webkit-scrollbar {
            width: 5px;
            height: 5px;
          }
          .my-row-box::-webkit-scrollbar-thumb {
            background-color: #0003;
            border-radius: 10px;
            transition: all 0.2s ease-in-out;
          }
        }
      }
      //////第三个模块
      // .left-three {
      //   height: 634px;
      //   // border: 1px solid rgb(192, 240, 255);
      //   // margin-bottom: 40px;
      //   padding: 30px;
      //   background-color: #ffffff;
      //   border-radius: 8px;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: space-between;
      // }
    }
  }
}
.bottom-and-top {
  display: flex;
  justify-content: center;
  :deep(.el-icon) {
    font-size: 20px;
    cursor: pointer;
  }
  :deep(.el-divider__text.is-center) {
    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
      > p {
        margin-left: 3px;
        color: #666666;
        letter-spacing: 1px;
      }
    }
  }
}

:deep(.box-column.column3){
  margin-bottom:0px;
}
</style>
